// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__RbkE4","modalFooterButton":"ModalNotes_modalFooterButton__2rli3"};